import React from 'react';
import { Switch, Route, RouteComponentProps, Redirect } from 'react-router-dom';
import { RtbCampaignSetupFlowPage } from './RtbCampaignSetupFlow/RtbCampaignSetupFlowPage';
import styles from './rtbCampaigns.module.scss';
import { withErrorBoundary } from 'hoc/withErrorBoundary';
import { ERROR_CODE } from 'core/ErrorCode';
import CoreContext from 'contexts/coreContext';
import _ from 'lodash';
import { RtbCampaignDraftsProps } from './RtbCampaignDraftsModel';
import RouteWithPermission from 'components/RouteWithPermission/RouteWithPermission';
import { ROUTE_PATH } from 'enum/RoutePath';
import { Permission } from 'core/auth/Permission';
import {
  addOnEnabled,
  hasFuncs,
  notArchivedChannel
} from 'core/permission/PermissionDSL';
import { ADDONFEATURE } from 'core/agency/AddonFeature';
import { ChannelGroupSetting } from 'core/channelGroup/ChannelGroupSettings';

const EditCampaignDraftView = withErrorBoundary(
  ERROR_CODE.DRAFT_EDIT,
  RtbCampaignSetupFlowPage
);

export class RtbCampaignDrafts extends React.Component<
  RouteComponentProps<any> & RtbCampaignDraftsProps
> {
  renderEditCampaignDraftView = (localeMeta, props) => {
    const draftId = props.match.params.draftId;
    return (
      <EditCampaignDraftView
        {...props}
        model={this.props.model.getEdtiCampaignDraftModel(draftId, localeMeta)}
      />
    );
  };

  redirectToL1Object = (props) => {
    const match = props.match.url.match(/\/campaign-groups\/\d+\//);
    return <Redirect to={`${match[0].slice(0, -1)}`} />;
  };

  render() {
    return (
      <div className={styles.container}>
        <CoreContext.Consumer>
          {(coreContext) => {
            const localeMeta = coreContext?.accountManager.localeMeta;
            return (
              <Switch>
                <RouteWithPermission
                  permissionAware={hasFuncs(Permission.CAMPAIGN_WRITE)
                    .and(
                      addOnEnabled(
                        ChannelGroupSetting.getAddonNameOfChannel(
                          this.props.model.channel
                        ) || ADDONFEATURE.CHANNEL[this.props.model.channel]
                      )
                    )
                    // ECOPD-5566：草稿編輯是獨立掛載的 route，不吃活動那條 modifyPermission，
                    // 列表入口藏起來後仍可直接打網址進來，所以這裡要自己擋
                    .and(notArchivedChannel(this.props.model.channelGroupId))}
                  redirectPath={`${this.props.match.url}/${ROUTE_PATH.ERROR403}`}
                  exact
                  path={`${this.props.match.url}/:draftId/edit`}
                  render={_.partial(
                    this.renderEditCampaignDraftView,
                    localeMeta
                  )}
                />
                <Route render={this.redirectToL1Object} />
              </Switch>
            );
          }}
        </CoreContext.Consumer>
      </div>
    );
  }
}
